import { ProjectGroupsList } from "../../pages/ProjectGroups";

export const EnduserProjectGroupsList = () => {
  return <ProjectGroupsList isEnduser />;
};

export default EnduserProjectGroupsList;
